import { getQueryPager } from 'public/components/query-table/utils'

export default function createModule () {
  return {
    namespaced: true,
    state: {
      query: [], // {data: {page: 1}, res: {rowTotal: 0, rows: []}}
      pager: { ids: [], total: 0 },
      sortIndexs: null
    },
    mutations: {
      SET_QUERY (state, payload) {
        let obj = state.query[payload.index]
        if (obj) {
          if (payload.data) {
            if (obj.data) {
              Object.assign(obj.data, payload.data)
            } else {
              obj.data = payload.data
            }
            delete payload.data
          }
          Object.assign(obj, payload)
          state.query.splice(payload.index, 1, obj)
        } else {
          state.query.push(payload)
        }
      },
      SET_PAGER (state, payload) {
        let obj = state.query[payload.index]
        if (obj && obj.res && obj.res.rows) {
          let idKey = payload.idKey || 'id'
          if (payload.ids) {
            // 运单录入的需求：自己控制 ids
            obj.res.rows = payload.ids.map(v => ({ [idKey]: v }))
            state.pager = payload
          } else {
            let pager = getQueryPager(idKey, obj.res.rows)
            // 本地排序后数组顺序需要保持一致
            if (state.sortIndexs) {
              let ids = pager.ids
              let ids2 = []
              state.sortIndexs.forEach((index, i) => {
                ids2[i] = ids[index]
              })
              pager.ids = ids2
            }
            state.pager = pager
          }
        }
      },
      UPDATE_PAGER (state, payload) {
        state.pager = { ...state.pager, ...payload }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/store/modules/queryTable/factory.js